<template>
  <div class="content">
    <div class="home">
      <div class="heard">

        <el-form :model="querySearch" label-width="80px">

          <el-row>
            <el-col :span="9">

              <el-form-item label="活动时间:">
                <el-date-picker @change="changeTime" v-model="forceTime" type="datetimerange" range-separator="至"
                  start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss"
                  :default-time="['', '23:59:59']" style="width: 100%;">
                </el-date-picker>
              </el-form-item>

            </el-col>

            <el-col :span="5">

              <el-form-item label="商品名称:">
                <el-input clearable v-model="querySearch.condition.productName" placeholder="请输入商品名称"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="5">
              <el-form-item label="活动状态:">
                <el-select clearable v-model="querySearch.condition.productStatus" placeholder="请选择"
                  style="width: 100%">
                  <el-option label="全部" :value="null"></el-option>
                  <el-option label="上架" :value="1"></el-option>
                  <el-option label="下架" :value="2"></el-option>
                </el-select>

              </el-form-item>
            </el-col>
            <el-col :span="4" style="margin-left: 20px; width: 160px;">
              <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
              <el-button type="info" icon="el-icon-refresh" @click="reset">重置</el-button>
            </el-col>

          </el-row>
        </el-form>

        <!--        <el-row :gutter="10">-->
        <!--          <el-col :span="8">-->
        <!--            <div class="item-col">-->
        <!--              <span class="label">商品名称 </span>-->
        <!--              <div>-->
        <!--                <el-input-->
        <!--                  style="width: 80%"-->
        <!--                  v-model="querySearch.condition.productName"-->
        <!--                  placeholder="请输入"-->
        <!--                ></el-input>-->
        <!--              </div></div-->
        <!--          ></el-col>-->

        <!--          <el-col :span="8">-->
        <!--            <div class="item-col">-->
        <!--              <span class="label">活动状态 </span>-->
        <!--              <div>-->
        <!--                <el-select-->
        <!--                  v-model="querySearch.condition.productStatus"-->
        <!--                  placeholder="请选择"-->
        <!--                  style="width: 80%"-->
        <!--                >-->
        <!--                  <el-option label="上架" :value="1"> </el-option>-->
        <!--                  <el-option label="下架" :value="2"> </el-option>-->
        <!--                </el-select>-->
        <!--              </div></div-->
        <!--          ></el-col>-->

        <!--          <el-col :span="20">-->
        <!--            <div class="item-col">-->
        <!--              <span class="label">创建时间</span>-->
        <!--              <div>-->
        <!--                <el-date-picker-->
        <!--                  v-model="forceTime"-->
        <!--                  type="datetimerange"-->
        <!--                  range-separator="至"-->
        <!--                  start-placeholder="开始日期"-->
        <!--                  end-placeholder="结束日期"-->
        <!--                  value-format="yyyy-MM-dd HH:mm:ss" :default-time="['', '23:59:59']"-->
        <!--                  @change="changeTime"-->
        <!--                >-->
        <!--                </el-date-picker>-->
        <!--              </div>-->
        <!--            </div>-->
        <!--          </el-col>-->
        <!--        </el-row>-->
        <!--        <el-row :gutter="10">-->
        <!--          <el-col :span="5"-->
        <!--            ><el-button-->
        <!--              type="primary"-->
        <!--              icon="el-icon-search"-->
        <!--              @click="search()"-->
        <!--              >查询</el-button-->
        <!--            >-->
        <!--            <el-button type="info" icon="el-icon-refresh" @click="reset()"-->
        <!--              >重置</el-button-->
        <!--            >-->
        <!--          </el-col>-->
        <!--        </el-row>-->
      </div>
      <div class="main">
        <div class="add-box">
          <el-button type="primary" plain style="font-size: 16px" @click="addSeckill">新增秒杀</el-button>
          <div style="margin: 0 20px;">
            活动状态：
            <el-switch @change="changeStatus(1)" active-value="1" inactive-value="0" v-model="isStatus"></el-switch>
          </div>
          <div>
            是否上热搜推荐：
            <el-switch @change="changeStatus(2)" active-value="1" inactive-value="0" v-model="isSearch"></el-switch>
          </div>
        </div>
        <div class="main-table" style="position: relative">
          <el-table v-loading="loading" :data="tableList" style="position: absolute" border height="100%">
            <el-table-column type="selection" width="100" align="center">
            </el-table-column>
            <el-table-column label="序号" type="index" width="80" align="center">
            </el-table-column>
            <el-table-column prop="productName" label="商品名称" width="200" align="center">
            </el-table-column>
            <el-table-column prop="name" label="活动时间" width="300" align="center">
              <template slot-scope="{ row }">
                <span>{{ row.startTime }}~{{ row.endTime }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="saleVolume" label="已售销量" width="100" align="center">
            </el-table-column>
            <el-table-column prop="stock" label="剩余库存" width="100" align="center">
            </el-table-column>
            <el-table-column prop="sort" label="商品排序" width="100" sortable align="center">
            </el-table-column>
            <el-table-column prop="productStatus" label="商品状态" width="120" align="center">
              <template slot-scope="{ row }">
                <el-button v-if="row.productStatus == 2" type="warning" plain>下架</el-button>
                <el-button v-if="row.productStatus == 1" type="success" plain>上架</el-button>
              </template>
            </el-table-column>
            <el-table-column prop="creator" label="创建人" width="100" align="center">
            </el-table-column>
            <el-table-column prop="createTime" label="创建时间" width="180" align="center">
            </el-table-column>
            <el-table-column label="操作" width="200" align="center">
              <template slot-scope="{ row }">
                <div>
                  <el-button type="text" size="small" @click="editProduct(row)">编辑</el-button>
                  <el-button type="text" size="small" @click="copyProduct(row)">复制</el-button>
                  <el-button type="text" size="small" @click="delSeckillProduct(row)" style="color: red;">删除</el-button>
                  <el-button type="text" size="small" @click="editSort(row)" style="color: red;">商品排序</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="page">
          <el-pagination background layout="prev, pager, next" :total="count" :page-size="10">
          </el-pagination>
        </div>
      </div>
    </div>

    <el-dialog title="商品排序" :visible.sync="dialogFormVisible">
      <el-form ref="sortFrom" :model="form" :rules="rules">
        <el-form-item label="排序" label-width="60px" prop="sort">
          <el-input v-model="form.sort" autocomplete="off"></el-input>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveSort">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// import productChildren from "./components/productChildren.vue";
export default {
  components: {
    // productChildren
  },
  data () {
    var sortValidator = (rule, value, callback) => {
      console.log(value, 257)
      if (!value) {
        return callback(new Error('排序内容不能为空'))
      }
      // 使用正则表达式验证整数且在1到100之间
      const regex = /^(?:[1-9][0-9]?|100)$/ // 1 到 100 的正则表达式

      if (!regex.test(value)) {
        return callback(new Error('请输入1到100之间的整数'))
      }
      callback()
    }
    return {
      forceTime: [],
      querySearch: {
        condition: {
          startTime: '',
          endTime: '',
          productName: '',
          seckillStatus: 0
        },
        count: 0,
        currPage: 1,
        pageCount: 0,
        pageSize: 10
      },
      tableList: [],
      count: 0,
      loading: true,
      btnloading: false,
      isStatus: 0,
      isSearch: 0,
      statusInfo: {},
      form: {
        sort: ''
      },
      obj: {},
      rules: {
        sort: [
          { validator: sortValidator, trigger: 'blur' }
        ]
      },
      dialogFormVisible: false

    }
  },
  created () {
    this.getSeckillProductList()
    this.getStatus()
  },
  methods: {
    changeTime (data) {
      if (data) {
        this.querySearch.condition.startTime = data[0]
        this.querySearch.condition.endTime = data[1]
      } else {
        this.forceTime = []
        this.querySearch.condition.startTime = ''
        this.querySearch.condition.endTime = ''
      }
    },
    copyProduct (row) {
      if (this.btnloading) {
        return
      }
      this.btnloading = true
      this.$confirm('确认复制该条数据吗？, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http
          .post('/seckillProduct/copySeckillProduct', {
            seckillCode: row.seckillCode
          })
          .then((res) => {
            console.log(res)
            if (res.data.code === 200) {
              this.$message({
                message: '复制成功！',
                type: 'success'
              })
              this.search()
            }
            this.btnloading = false
          }).catch(err => {
            this.btnloading = false
          })
      })
    },
    search () {
      this.querySearch.currPage = 1
      this.getSeckillProductList()
    },
    editSort (item) {
      this.form.sort = item.sort
      this.obj = item
      this.dialogFormVisible = true
    },

    saveSort () {
      this.$refs['sortFrom'].validate(async (valid) => {
        if (valid) {
          this.obj.sort = this.form.sort
          const res = await this.$http.post('seckillProduct/update', this.obj)
          if (res.data.code === 200) {
            this.$message.success('修改成功')
            this.dialogFormVisible = false
            await this.getProductActivity()
          } else {
            this.$message.error(res.data.message)
          }
        } else {
          console.log('error', valid)
        }
      })
    },
    reset () {
      this.querySearch.condition.startTime = ''
      this.querySearch.condition.endTime = ''
      this.forceTime = []
      this.querySearch.condition.productName = ''
      this.querySearch.condition.seckillStatus = 0
      this.querySearch.currPage = 1
      this.querySearch.pageSize = 10
      this.getSeckillProductList()
    },
    async getSeckillProductList () {
      let _this = this
      _this.loading = true
      this.$http
        .post('/seckillProduct/listAll', _this.querySearch)
        .then(function (res) {
          let { code, data } = res.data
          if (code === 200) {
            _this.tableList = data.data
            _this.count = data.count
            _this.loading = false
          }
        })
    },
    async getStatus () {
      const res = await this.$http.post('systemConfig/queryOne', {
        propertyIndex: 9,
        systemId: '1000'
      })
      if (res.data.code === 200) {
        this.statusInfo = res.data.data
        this.isStatus = res.data.data.propertyValue.split(',')[0]
        this.isSearch = res.data.data.propertyValue.split(',')[1]
        console.log(this.isStatus, this.isSearch)
      }
    },
    async changeStatus (val) {

      if(this.isStatus == 0){
        this.isSearch = 0
      }

      let propertyValue = this.isStatus + ',' + this.isSearch
      this.statusInfo.propertyValue = propertyValue
      console.log(this.statusInfo)
      const res = await this.$http.post('systemConfig/update', this.statusInfo)
      if(val===1){
        this.isStatus == 1 ? this.$message.success("活动上架成功") :this.$message.success("活动下架成功")
      }

      if(val===2){
        this.isSearch == 1 ? this.$message.success("该活动已上热搜") :this.$message.success("该活动已下热搜")
      }
    },
    addSeckill () {
      this.$router.push('/addSeckillProduct')
    },
    editProduct (row) {
      this.$router.push('/addSeckillProduct?seckillProductCode=' + row.seckillProductCode)
    },
    // 删除秒杀商品
    async delSeckillProduct (row) {
      let _this = this
      this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$http
            .post('/seckillProduct/delete', {
              id: row.id,
              seckillProductCode: row.seckillProductCode
            })
            .then(function (res) {
              if (res.data.code == 200) {
                _this.$message({
                  message: '删除成功!',
                  type: 'success'
                })
                _this.getSeckillProductList()
              } else {
                _this.$message({
                  message: res.data.message,
                  type: 'fail'
                })
              }
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    }
  }
}
</script>
<style lang="less" scoped>
.content {
  height: 100% !important;

  .home {
    height: 100% !important;
    display: flex;
    flex-direction: column;
    background-color: #eef1f6;
    padding: 10px;
    box-sizing: border-box;
  }

  .heard {
    background-color: #fff;
    height: auto;
    padding: 15px;

    .item-col {
      display: flex;
      align-items: center;
      margin-bottom: 18px;

      .label {
        width: fit-content;
        margin-right: 10px;
      }

      div {
        flex: 1;
      }
    }
  }

  .main {
    margin-top: 20px;
    flex: 1;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    padding: 15px;

    .main-table {
      flex: 1;
      overflow: hidden;
    }

    .page {
      display: flex;
      justify-content: flex-end;
    }

    .add-box {
      display: flex;
      align-items: center;
    }
  }
}

/deep/ .el-tabs__nav-wrap::after {
  position: static !important;
}

/deep/ .el-tabs__active-bar {
  background-color: transparent !important;
}

/deep/ .el-tabs__nav.is-top {
  width: 100%;
  padding: 10px 0;
  display: flex;
  justify-content: space-around;
  background-color: #dff0f9;
  overflow-y: auto;
}

/deep/ .item-elbtn {
  margin-left: 0;
  padding: 0 2px;
}

.el-button {
  padding: 0 10px;
}
</style>
